import { useCallback } from 'react'
import constants from 'app/constants'
import { useUserContext } from 'app/services/UserProvider/UserProvider'
import { useModalContext } from '../Modal/provider/ModalProvider'

/**
 * The `useHandleNavClickLink`. Used to keep nav link
 * click behaviors in one place
 *
 * @returns {Function} the callback handler
 */
function useHandleNavClickLink () {
  const { logoutUser } = useUserContext()
  const { showModal } = useModalContext()

  /**
   * Handle nav link clicks
   */
  const handleClick = useCallback(
    (e, { action, validation }) => {
      if (action === 'privacy_terms') {
        return showModal({
          id: 'app:privacy_terms'
        })
      }

      if (action === 'newsletter') {
        return showModal({
          id: 'app:newsletter'
        })
      }

      if (action === 'validate') {
        if (validation === 'marketplace' && !constants.IS_MARKETPLACE_ENABLED) {
          e.preventDefault()

          return showModal({
            id: 'app:marketplace:locked'
          })
        }
      }

      if (action === 'sign_in') {
        return showModal({
          id: 'app:sign_in'
        })
      }

      if (action === 'sign_out') {
        return logoutUser()
      }
    },
    [logoutUser]
  )

  return handleClick
}

// Export
export default useHandleNavClickLink
